import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "events-timeline box" }
const _hoisted_2 = { class: "events-timeline-title" }
const _hoisted_3 = { class: "is-size-5 has-text-success" }
const _hoisted_4 = {
  key: 0,
  class: "events-timeline-content"
}
const _hoisted_5 = {
  key: 1,
  class: "events-timeline-content center"
}
const _hoisted_6 = {
  key: 2,
  class: "events-timeline-content center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-calendar-remove-outline is-size-3 mb-3" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "is-size-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_timeline_item = _resolveComponent("n-timeline-item")!
  const _component_n_timeline = _resolveComponent("n-timeline")!
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('events_timeline.title')), 1 /* TEXT */)
    ]),
    (_ctx.timelineEvents?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_n_timeline, {
            "item-placement": "right",
            size: "large"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timelineEvents, (event) => {
                return (_openBlock(), _createBlock(_component_n_timeline_item, {
                  key: event?.date,
                  color: _ctx.getEventColor(event),
                  content: _ctx.getEventContent(event),
                  time: _ctx.moment(event?.date * 1000).format('LLL')
                }, null, 8 /* PROPS */, ["color", "content", "time"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : (_ctx.events === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_n_spin, { size: "large" })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('events_timeline.no_events')), 1 /* TEXT */)
          ]))
  ]))
}